import {EyeIcon} from "@/components/shared";
import {useEffect, useState} from "react";
import Loader from "../Loader";

interface AttendanceInconsistencyProps {
  totalInconsistencies: number;
  affectedStudents: number;
  totalStudents: number;
  noSchoolArrival: number;
  noSchoolEntry: number;
  noBusPickup: number;
  pickupDropMismatchCount: number;
}

interface percentageData {
  percentArrival: number;
  percentEntry: number;
  percentPickup: number;
  percentMismatch: number;
}
interface AttendanceInconsistencywidgetProps {
  attendanceInconsistency: AttendanceInconsistencyProps;
  isLoading: boolean;
  instituteuserids: any;
  openPopup: (title: popupParams) => void;
}
const AttendanceInconsistencySummarywidget: React.FC<
  AttendanceInconsistencywidgetProps
> = ({isLoading, attendanceInconsistency, instituteuserids, openPopup}) => {
  const [percentageData, setpercentageData] = useState<percentageData>({
    percentArrival: 0,
    percentEntry: 0,
    percentPickup: 0,
    percentMismatch: 0
  });

  useEffect(() => {
    const total = attendanceInconsistency.totalInconsistencies;
    const percentArrival = attendanceInconsistency.noSchoolArrival
      ? parseFloat(
          ((attendanceInconsistency.noSchoolArrival / total) * 100).toFixed(2)
        )
      : 0;
    const percentEntry = attendanceInconsistency.noSchoolEntry
      ? parseFloat(
          ((attendanceInconsistency.noSchoolEntry / total) * 100).toFixed(2)
        )
      : 0;
    const percentPickup = attendanceInconsistency.noBusPickup
      ? parseFloat(
          ((attendanceInconsistency.noBusPickup / total) * 100).toFixed(2)
        )
      : 0;
    const percentMismatch = attendanceInconsistency.pickupDropMismatchCount
      ? parseFloat(
          (
            (attendanceInconsistency.pickupDropMismatchCount / total) *
            100
          ).toFixed(2)
        )
      : 0;
    setpercentageData({
      percentArrival: percentArrival,
      percentEntry: percentEntry,
      percentPickup: percentPickup,
      percentMismatch: percentMismatch
    });
  }, [attendanceInconsistency]);
  return (
    <>
      {/* main */}
      <div className="rounded-xl border bg-neo-white p-2">
        <div className=" flex items-center justify-between ">
          <div className="flex items-center gap-1">
            <div className=" text-lg font-semibold">
              Attendance Inconsistency Summary
            </div>

            {/* <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.75 0C7.82164 0 5.93657 0.571828 4.33319 1.64317C2.72982 2.71451 1.48013 4.23726 0.742179 6.01884C0.00422452 7.80042 -0.188858 9.76082 0.187348 11.6521C0.563554 13.5434 1.49215 15.2807 2.85571 16.6443C4.21928 18.0079 5.95656 18.9365 7.84787 19.3127C9.73919 19.6889 11.6996 19.4958 13.4812 18.7578C15.2627 18.0199 16.7855 16.7702 17.8568 15.1668C18.9282 13.5634 19.5 11.6784 19.5 9.75C19.4973 7.16498 18.4692 4.68661 16.6413 2.85872C14.8134 1.03084 12.335 0.00272983 9.75 0ZM9.375 4.5C9.59751 4.5 9.81501 4.56598 10 4.6896C10.185 4.81321 10.3292 4.98891 10.4144 5.19448C10.4995 5.40005 10.5218 5.62625 10.4784 5.84448C10.435 6.06271 10.3278 6.26316 10.1705 6.4205C10.0132 6.57783 9.81271 6.68498 9.59448 6.72838C9.37625 6.77179 9.15005 6.74951 8.94449 6.66436C8.73892 6.57922 8.56322 6.43502 8.4396 6.25002C8.31598 6.06501 8.25 5.8475 8.25 5.625C8.25 5.32663 8.36853 5.04048 8.57951 4.8295C8.79049 4.61853 9.07664 4.5 9.375 4.5ZM10.5 15C10.1022 15 9.72065 14.842 9.43934 14.5607C9.15804 14.2794 9 13.8978 9 13.5V9.75C8.80109 9.75 8.61033 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61033 8.32902 8.80109 8.25 9 8.25C9.39783 8.25 9.77936 8.40804 10.0607 8.68934C10.342 8.97064 10.5 9.35218 10.5 9.75V13.5C10.6989 13.5 10.8897 13.579 11.0303 13.7197C11.171 13.8603 11.25 14.0511 11.25 14.25C11.25 14.4489 11.171 14.6397 11.0303 14.7803C10.8897 14.921 10.6989 15 10.5 15Z"
                  fill="#AFAFAF"
                />
              </svg>
            </div> */}
          </div>

          <div>
            <h5
              className="cursor-pointer pr-2"
              title="View"
              onClick={() =>
                openPopup({title: "Attendance Inconsistency Summary"})
              }
            >
              <EyeIcon size={18} />
            </h5>
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="mb-2 text-xs text-gray-600">
              A user may appear in more than one category.
            </div>
            <div className="flex justify-between rounded-lg border bg-red-50 p-2 px-6">
              <div className="flex flex-col items-center gap-1">
                <div>
                  <svg
                    width="28"
                    height="25"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.5 0C7.3872 0 0 7.3872 0 16.5C0 25.6128 7.3872 33 16.5 33C25.6128 33 33 25.6128 33 16.5C33 7.3872 25.6128 0 16.5 0ZM18.0872 19.5684L18.538 6.47989C18.538 5.49163 17.7999 4.68307 16.8966 4.68307H16.1034C15.2009 4.68307 14.462 5.49163 14.462 6.47989L14.9128 19.5684C14.9128 20.5242 15.6275 21.3061 16.5 21.3061C17.3733 21.3061 18.0872 20.5242 18.0872 19.5684ZM16.5 23.9948C15.3062 23.9948 14.339 24.9629 14.339 26.1559C14.339 27.3497 15.307 28.3169 16.5 28.3169C17.6938 28.3169 18.6618 27.3489 18.6618 26.1559C18.661 24.9629 17.6938 23.9948 16.5 23.9948Z"
                      fill="#EF4444"
                    />
                  </svg>
                </div>
                <div className="text-xl font-bold text-red-600">
                  {attendanceInconsistency.totalInconsistencies}
                </div>
                <div className="text-xs font-bold">Total Inconsistencies</div>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div>
                  <svg
                    width="33"
                    height="25"
                    viewBox="0 0 36 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.1 0C9.29347 0 10.4381 0.477398 11.282 1.32717C12.1259 2.17695 12.6 3.32949 12.6 4.53125C12.6 5.73301 12.1259 6.88555 11.282 7.73533C10.4381 8.5851 9.29347 9.0625 8.1 9.0625C6.90653 9.0625 5.76193 8.5851 4.91802 7.73533C4.07411 6.88555 3.6 5.73301 3.6 4.53125C3.6 3.32949 4.07411 2.17695 4.91802 1.32717C5.76193 0.477398 6.90653 0 8.1 0ZM28.8 0C29.9935 0 31.1381 0.477398 31.982 1.32717C32.8259 2.17695 33.3 3.32949 33.3 4.53125C33.3 5.73301 32.8259 6.88555 31.982 7.73533C31.1381 8.5851 29.9935 9.0625 28.8 9.0625C27.6065 9.0625 26.4619 8.5851 25.618 7.73533C24.7741 6.88555 24.3 5.73301 24.3 4.53125C24.3 3.32949 24.7741 2.17695 25.618 1.32717C26.4619 0.477398 27.6065 0 28.8 0ZM0 16.9186C0 13.5824 2.68875 10.875 6.00187 10.875H8.40375C9.29812 10.875 10.1475 11.0732 10.9125 11.4244C10.8394 11.8322 10.8056 12.257 10.8056 12.6875C10.8056 14.8512 11.7506 16.7939 13.2412 18.125C13.23 18.125 13.2187 18.125 13.2019 18.125H1.19812C0.54 18.125 0 17.5813 0 16.9186ZM22.7981 18.125C22.7869 18.125 22.7756 18.125 22.7587 18.125C24.255 16.7939 25.1944 14.8512 25.1944 12.6875C25.1944 12.257 25.155 11.8379 25.0875 11.4244C25.8525 11.0676 26.7019 10.875 27.5963 10.875H29.9981C33.3112 10.875 36 13.5824 36 16.9186C36 17.5869 35.46 18.125 34.8019 18.125H22.7981ZM12.6 12.6875C12.6 11.2454 13.1689 9.86234 14.1816 8.84261C15.1943 7.82288 16.5678 7.25 18 7.25C19.4322 7.25 20.8057 7.82288 21.8184 8.84261C22.8311 9.86234 23.4 11.2454 23.4 12.6875C23.4 14.1296 22.8311 15.5127 21.8184 16.5324C20.8057 17.5521 19.4322 18.125 18 18.125C16.5678 18.125 15.1943 17.5521 14.1816 16.5324C13.1689 15.5127 12.6 14.1296 12.6 12.6875ZM7.2 27.4877C7.2 23.3189 10.5581 19.9375 14.6981 19.9375H21.3019C25.4419 19.9375 28.8 23.3189 28.8 27.4877C28.8 28.3203 28.1306 29 27.2981 29H8.70187C7.875 29 7.2 28.326 7.2 27.4877Z"
                      fill="#F28A03"
                    />
                  </svg>
                </div>
                <div className="text-xl font-bold text-[#F28A03]">
                  {attendanceInconsistency.affectedStudents}/
                  {attendanceInconsistency.totalStudents}
                </div>
                <div className="text-xs font-bold">Affected User</div>
              </div>
            </div>
            {/* g */}
            <div className="mt-2 grid grid-cols-2 gap-1">
              <div className="flex items-center gap-2 rounded-lg border p-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-200">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.4733 0C17.4968 0 21.5124 1.57758 21.5124 3.5854V4.30248V5.73664C22.3057 5.73664 22.9466 6.37753 22.9466 7.1708V10.0391C22.9466 10.8324 22.3057 11.4733 21.5124 11.4733V18.6441C21.5124 19.4374 20.8715 20.0782 20.0782 20.0782V21.5124C20.0782 22.3057 19.4374 22.9466 18.6441 22.9466H17.2099C16.4167 22.9466 15.7758 22.3057 15.7758 21.5124V20.0782H7.1708V21.5124C7.1708 22.3057 6.52991 22.9466 5.73664 22.9466H4.30248C3.50921 22.9466 2.86832 22.3057 2.86832 21.5124V20.0782C2.07505 20.0782 1.43416 19.4374 1.43416 18.6441V11.4733C0.64089 11.4733 0 10.8324 0 10.0391V7.1708C0 6.37753 0.64089 5.73664 1.43416 5.73664V4.30248V3.5854C1.43416 1.57758 5.44981 0 11.4733 0ZM4.30248 7.1708V11.4733C4.30248 12.2666 4.94337 12.9074 5.73664 12.9074H10.7562V5.73664H5.73664C4.94337 5.73664 4.30248 6.37753 4.30248 7.1708ZM12.1904 12.9074H17.2099C18.0032 12.9074 18.6441 12.2666 18.6441 11.4733V7.1708C18.6441 6.37753 18.0032 5.73664 17.2099 5.73664H12.1904V12.9074ZM5.01956 17.927C5.39992 17.927 5.76471 17.7759 6.03367 17.5069C6.30262 17.238 6.45372 16.8732 6.45372 16.4928C6.45372 16.1125 6.30262 15.7477 6.03367 15.4787C5.76471 15.2098 5.39992 15.0587 5.01956 15.0587C4.6392 15.0587 4.27441 15.2098 4.00546 15.4787C3.7365 15.7477 3.5854 16.1125 3.5854 16.4928C3.5854 16.8732 3.7365 17.238 4.00546 17.5069C4.27441 17.7759 4.6392 17.927 5.01956 17.927ZM17.927 17.927C18.3074 17.927 18.6722 17.7759 18.9411 17.5069C19.2101 17.238 19.3612 16.8732 19.3612 16.4928C19.3612 16.1125 19.2101 15.7477 18.9411 15.4787C18.6722 15.2098 18.3074 15.0587 17.927 15.0587C17.5466 15.0587 17.1819 15.2098 16.9129 15.4787C16.6439 15.7477 16.4928 16.1125 16.4928 16.4928C16.4928 16.8732 16.6439 17.238 16.9129 17.5069C17.1819 17.7759 17.5466 17.927 17.927 17.927ZM15.7758 3.5854C15.7758 3.19101 15.4531 2.86832 15.0587 2.86832H7.88788C7.49349 2.86832 7.1708 3.19101 7.1708 3.5854C7.1708 3.97979 7.49349 4.30248 7.88788 4.30248H15.0587C15.4531 4.30248 15.7758 3.97979 15.7758 3.5854Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div>
                  <div className="text-lg font-bold">
                    {attendanceInconsistency.noSchoolArrival}
                  </div>
                  <div className="text-xs text-gray-600">
                    Boarded Bus – No School Arrival
                  </div>
                  <div>
                    <h5 className="flex justify-end text-xs">
                      {percentageData.percentArrival}%
                    </h5>
                    <div className="h-1 w-full rounded bg-[#dadadc]">
                      <div
                        className="h-1 rounded  bg-[#FFC727]"
                        style={{width: `${percentageData?.percentArrival}%`}}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* 1 */}
              <div className="flex items-center gap-2 rounded-lg border p-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-200">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 18 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.9987 0C9.49792 0 9.95847 0.263672 10.2116 0.696094L17.8053 13.6336C18.062 14.0695 18.062 14.6074 17.8124 15.0434C17.5628 15.4793 17.0952 15.75 16.5925 15.75H1.40495C0.902218 15.75 0.43464 15.4793 0.18503 15.0434C-0.0645789 14.6074 -0.0610632 14.066 0.192062 13.6336L7.78581 0.696094C8.03894 0.263672 8.49948 0 8.9987 0ZM8.9987 4.5C8.53112 4.5 8.15495 4.87617 8.15495 5.34375V9.28125C8.15495 9.74883 8.53112 10.125 8.9987 10.125C9.46628 10.125 9.84245 9.74883 9.84245 9.28125V5.34375C9.84245 4.87617 9.46628 4.5 8.9987 4.5ZM10.1237 12.375C10.1237 12.0766 10.0052 11.7905 9.7942 11.5795C9.58322 11.3685 9.29707 11.25 8.9987 11.25C8.70033 11.25 8.41418 11.3685 8.20321 11.5795C7.99223 11.7905 7.8737 12.0766 7.8737 12.375C7.8737 12.6734 7.99223 12.9595 8.20321 13.1705C8.41418 13.3815 8.70033 13.5 8.9987 13.5C9.29707 13.5 9.58322 13.3815 9.7942 13.1705C10.0052 12.9595 10.1237 12.6734 10.1237 12.375Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div>
                  <div className="text-lg font-bold">
                    {attendanceInconsistency.noSchoolEntry}
                  </div>
                  <div className="text-xs text-gray-600">
                    Dropped at School – No School Entry
                  </div>
                  <div>
                    <h5 className="flex justify-end text-xs">
                      {percentageData.percentEntry}%
                    </h5>
                    <div className="h-1 w-full rounded bg-[#dadadc]">
                      <div
                        className="h-1 rounded  bg-[#FFC727]"
                        style={{width: `${percentageData?.percentEntry}%`}}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="flex items-center gap-2 rounded-lg border p-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-200">
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 21 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 2.25H20.25C20.25 1.00898 19.241 0 18 0H2.25C1.00898 0 0 1.00898 0 2.25ZM0 3.375V13.5C0 14.741 1.00898 15.75 2.25 15.75H18C19.241 15.75 20.25 14.741 20.25 13.5V3.375H0ZM2.25 13.1238C2.25 12.0867 3.09023 11.25 4.12383 11.25H8.25117C9.28828 11.25 10.125 12.0902 10.125 13.1238C10.125 13.3313 9.95625 13.5 9.74883 13.5H2.62617C2.41875 13.5 2.25 13.3313 2.25 13.1238ZM6.1875 5.625C6.78424 5.625 7.35653 5.86205 7.77849 6.28401C8.20045 6.70597 8.4375 7.27826 8.4375 7.875C8.4375 8.47174 8.20045 9.04403 7.77849 9.46599C7.35653 9.88795 6.78424 10.125 6.1875 10.125C5.59076 10.125 5.01847 9.88795 4.59651 9.46599C4.17455 9.04403 3.9375 8.47174 3.9375 7.875C3.9375 7.27826 4.17455 6.70597 4.59651 6.28401C5.01847 5.86205 5.59076 5.625 6.1875 5.625ZM12.375 6.1875C12.375 5.87813 12.6281 5.625 12.9375 5.625H17.4375C17.7469 5.625 18 5.87813 18 6.1875C18 6.49687 17.7469 6.75 17.4375 6.75H12.9375C12.6281 6.75 12.375 6.49687 12.375 6.1875ZM12.375 8.4375C12.375 8.12813 12.6281 7.875 12.9375 7.875H17.4375C17.7469 7.875 18 8.12813 18 8.4375C18 8.74687 17.7469 9 17.4375 9H12.9375C12.6281 9 12.375 8.74687 12.375 8.4375ZM12.375 10.6875C12.375 10.3781 12.6281 10.125 12.9375 10.125H17.4375C17.7469 10.125 18 10.3781 18 10.6875C18 10.9969 17.7469 11.25 17.4375 11.25H12.9375C12.6281 11.25 12.375 10.9969 12.375 10.6875Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div>
                  <div className="text-lg font-bold">
                    {attendanceInconsistency.noBusPickup}
                  </div>
                  <div className="text-xs text-gray-600">
                    School Entry – No Bus Pickup
                  </div>
                  <div>
                    <h5 className="flex justify-end text-xs">
                      {percentageData.percentPickup}%
                    </h5>
                    <div className="h-1 w-full rounded bg-[#dadadc]">
                      <div
                        className="h-1 rounded  bg-[#FFC727]"
                        style={{width: `${percentageData?.percentPickup}%`}}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* 3 */}
              <div className="flex items-center gap-2 rounded-lg border p-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-200">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM9 4.5C9.46758 4.5 9.84375 4.87617 9.84375 5.34375V9.28125C9.84375 9.74883 9.46758 10.125 9 10.125C8.53242 10.125 8.15625 9.74883 8.15625 9.28125V5.34375C8.15625 4.87617 8.53242 4.5 9 4.5ZM7.875 12.375C7.875 12.0766 7.99353 11.7905 8.2045 11.5795C8.41548 11.3685 8.70163 11.25 9 11.25C9.29837 11.25 9.58452 11.3685 9.7955 11.5795C10.0065 11.7905 10.125 12.0766 10.125 12.375C10.125 12.6734 10.0065 12.9595 9.7955 13.1705C9.58452 13.3815 9.29837 13.5 9 13.5C8.70163 13.5 8.41548 13.3815 8.2045 13.1705C7.99353 12.9595 7.875 12.6734 7.875 12.375Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div>
                  <div className="text-lg font-bold">
                    {attendanceInconsistency.pickupDropMismatchCount}
                  </div>
                  <div className="text-xs text-gray-600">
                    Morning pickup-Evening drop Count Mismatch
                  </div>
                  <div>
                    <h5 className="flex justify-end text-xs">
                      {percentageData.percentMismatch}%
                    </h5>
                    <div className="h-1 w-full rounded bg-[#dadadc]">
                      <div
                        className="h-1 rounded  bg-[#FFC727]"
                        style={{width: `${percentageData?.percentMismatch}%`}}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* g */}
          </>
        )}
      </div>
      {/* main */}
    </>
  );
};
export default AttendanceInconsistencySummarywidget;
